<template>
  <div class="px-20">
    <vs-popup
      class="custom-popup editPromo-popup"
      classContent="popup-example"
      :title="`${formData['actionName']} CNIC Promo`"
      :active.sync="editPromoRequestPopup"
    >
      <div slot="header">Edit CNIC Promo</div>

      <div>
        <div class="static-box-header">
          <div class="header">CNIC PROMOS</div>
          <div class="form-actions">
            <vx-tooltip text="Copy any end date manually and click here to paste it to all entries" position="top">
              <vs-button
                class="iconOnly"
                color="dark"
                type="flat"
                icon-pack="feather"
                icon="icon-copy"
                @click="copyEndDate"
              ></vs-button>
            </vx-tooltip>
          </div>
        </div>
        
        <div class="cnicPromo-editForm table-form pr-4 pl-4">
          <ul class="table-head">
            <li class="theading">Client Name</li>
            <li class="theading">Promo Name</li>
            <li class="theading">TLD</li>
            <li class="theading">CNIC ID</li>
            <li class="theading">Type</li>
            <li class="theading">Premium</li>
            <li class="theading">Effective</li>
            <li class="theading">Start Date</li>
            <li class="theading">End Date</li>
            <li class="theading">Start Time</li>
            <li class="theading">End Time</li>
            <li class="theading">Comments</li>
          </ul>
          <div v-for="(cnic, counter) in cnicpromo" v-bind:key="counter">
            <ul class="cnicpromo-repeater table-body p1">
              <li>
                <v-select
                  class="w-full"
                  v-validate="formData['CNICRequired']"
                  :name="`cnicRegName-${counter}`"
                  data-vv-validate-on="blur"
                  :disabled="true"
                  v-model="cnic.reg_id"
                  :options="formRegs"
                  :clearable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                ></v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`cnicTLD-${counter}`)"
                  >Required field</span
                >
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full promoname"
                    v-validate="formData['CNICRequired']"
                    name="Promo name"
                    data-vv-validate-on="blur"
                    v-model="cnic.promo_name"
                    :disabled="flags['disableInput']"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Promo name')"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['CNICRequired']"
                    :name="`cnicTLD-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="cnic.tld_id"
                    :options="formTlds"
                    :clearable="false"
                    :multiple="false"
                    :closeOnSelect="true"
                    :disabled="flags['disableInput']"
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`cnicTLD-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full cnicId"
                    v-validate="formData['CNICRequired']"
                    name="Promo name"
                    data-vv-validate-on="blur"
                    v-model="cnic.cnic_id"
                    :disabled="true"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('CNIC ID')"
                    >Required field</span
                  >
                </div>
              </li>
              <li style="width: 210px;">
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['CNICRequired']"
                    :name="`cnicType-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="cnic.type_of_reg"
                    :options="formInit['type_of_reg']"
                    :clearable="false"
                    :disabled="flags['disableInput']"
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`cnicType-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['CNICRequired']"
                    name="`cnicPremium-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="cnic.premium"
                    :options="formInit['premium']"
                    :clearable="false"
                    :disabled="flags['disableInput']"
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`cnicPremium-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div v-if="cnic.premium.value !== 1" class="w-full inputPrefix">
                    <vs-input
                      class="w-full"
                      v-validate="formData['CNICRequired']"
                      :name="`Effective Promo Price-${counter}`"
                      data-vv-validate-on="blur"
                      v-model="cnic.effective_price_amt"
                      :key="`amt-input-${counter}`"
                      :disabled="flags['disableInput']"
                    />
                    <span class="currency-sign">$</span>
                    <span
                      class="text-danger text-sm"
                      v-if="errors.has('Effective Promo Price-' + counter)"
                    >
                      {{
                        errors
                          .first("Effective Promo Price-" + counter)
                          .replace("The Effective Promo Price-" + counter, "This")
                      }}
                    </span>
                  </div>
                  <div v-else class="w-full inputPrefix">
                    <vs-input
                      class="w-full"
                      v-validate="'required'"
                      :name="`Percentage Discount-${counter}`"
                      data-vv-validate-on="blur"
                      v-model="cnic.effective_price_per"
                      :key="`per-input-${counter}`"
                      :disabled="flags['disableInput']"
                    />
                    <span class="currency-sign">%</span>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Percentage Discount-' + counter)"
                      >{{ errors.first("Percentage Discount") }}</span
                    >
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    v-validate="formData['CNICRequired']"
                    :name="`cnic Start date-${counter}`"
                    data-vv-validate-on="blur"
                    :config="cnic.configFromdateTimePicker"
                    v-model="cnic.start_date"
                    placeholder="YYYY-MM-DD"
                    @on-change="onFromChangeCNIC($event, counter)"
                    :disabled="flags['disableInput']"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('cnic Start date-' + counter)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div class="flex">
                    <flat-pickr
                      class="w-full"
                      v-validate="formData['CNICRequired']"
                      :name="`cnic End date-${counter}`"
                      data-vv-validate-on="blur"
                      :config="cnic.configTodateTimePicker"
                      v-model="cnic.end_date"
                      placeholder="YYYY-MM-DD"
                      @on-change="onToChangeCNIC($event, counter)"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('cnic End date-' + counter)"
                      >Required field</span
                    >
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    :config="configdateTimePicker"
                    v-model="cnic.start_time"
                    :disabled="flags['disableInput']"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('startTime')"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    :config="configdateEndTimePicker"
                    v-model="cnic.end_time"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('endTime')"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full"
                    :name="`Comments-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="cnic.comments"
                    :key="`comments-${counter}`"
                  >
                  </vs-input>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-end pb-4 pr-4 pt-2">
        <vs-button
          v-show="!flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onEditSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onDuplicateSubmit()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "EditCNICPromo",
  components: {
    "v-select": vSelect,
    flatPickr,
  },
  // props: {
  //   editReq: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      editReq: false,
      cnicRequestPopup: false,
      promoNameSpan: [],
      configdateTimePicker: {
        time_24hr: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:S",
        enableSeconds: true,
        defaultDate: "00:00:00",
        allowInput: true,
      },
      configdateEndTimePicker: {
        time_24hr: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:S",
        enableSeconds: true,
        defaultDate: "23:59:59",
        allowInput: true,
      },
      cnicpromo: [
        {
          id: "",
          reg_id: [],
          promo_name: "",
          tld_id: "",
          effective_price_amt: "",
          effective_price_per: "",
          price_type: [{ label: "$", value: "$" }],
          premium: { label: "No", value: 0 },
          group_id: null,
          type_of_reg: "",
          start_date: null,
          end_date: null,
          start_time: "",
          end_time: "",
          status: "",
          comments: "",
          configFromdateTimePicker: {
            minDate: new Date(),
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: "",
          selectedClient: "",
        },
      ],
      formData: {
        actionName:'',
        selectedPromoName: {
          selectedGroup: "",
          selectedTLD: "",
          selectedClient: "",
          selectedType: "",
          selectedPrem: "",
          selectedMonthYear: "",
          selectedClientId: "",
          selectedCountryId: "",
        },
        promo_name_new: "",
        status: "approval pending",
        displayTimezone: "(UTC)",
        CNICRequired: "required",
      },
      formInit: {
        reg_ids: [],
        tld_ids: [],
        type_of_reg: ["Registration", "Renewal"],
        premium: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
      extended: false,
      flags: {
        disableInput: false,
        duplicatebtn: false,
      },
      editPromoRequestPopup: false,
      PromoNamePartRecommendation: [],
      configFromdateTimePicker: {
        // minDate: new Date(),
        maxDate: null,
        wrap: true,
      },
      configTodateTimePicker: {
        minDate: null,
        wrap: true,
        allowInput: true
      },
    };
  },
  watch: {
    cnicpromo: {
      deep: true,
      handler() {
        this.promoNameFormations();
        // this.changeTimeZone();
      },
    },

    editPromoRequestPopup(val) {
      if (!val) {
        this.errors.clear();
        setTimeout(() => {
          this.flags["duplicatebtn"] = false;
          this.flags["disableInput"] = false;
        }, 10);
      }
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formRegs() {
      return this.$store.getters.formRegs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
      return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
      return this.$store.getters.formCustomTags;
    },
  },
  computed: {
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },

    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formRegs() {
      return this.$store.getters.formRegs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
      return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
      return this.$store.getters.formCustomTags;
    },

    // NOTE: Before Vuex usage
    // formResellers: function () {
    //   let resellerArray = this.formInit["reseller_ids"].map((x) => {
    //     return {
    //       label: x["name"],
    //       value: x["id"],
    //     };
    //   });

    //   return resellerArray;
    // },

    // formTlds: function () {
    //   let tldArray = this.formInit["tld_ids"].map((x) => {
    //     return {
    //       label: x["tld_name"],
    //       value: x["id"],
    //       name: x["tld_name"],
    //     };
    //   });

    //   return tldArray;
    // },

    // // formTldFiltered: function () {
    // //   var selectedTld = [];
    // //   this.cnicpromo.forEach((y) => {
    // //     y["tld_id"].forEach((x) => {
    // //       selectedTld.push(x.value);
    // //     });
    // //   });
    // //   // var selectedTld = this.tldValue.map(x=> x.value);
    // //   return this.formTlds.filter((x) => !selectedTld.includes(x["value"]));
    // // },

    // formPromoTags: function () {
    //   let promoTagArray = this.formInit["promo_tags"].map((x) => {
    //     return {
    //       label: x["tag_name"],
    //       value: x["id"],
    //     };
    //   });

    //   return promoTagArray;
    // },

    // formCustomTags: function () {
    //   let customTagArray = this.formInit["custom_tags"].map((x) => {
    //     return {
    //       label: x["tag_name"],
    //       value: x["id"],
    //     };
    //   });

    //   return [
    //     {
    //       label: "NA",
    //       value: null,
    //     },
    //     ...customTagArray,
    //   ];
    // },

    // formGeo: function () {
    //   let GeoCurrencyArray = this.formInit["geos"].map((x) => {
    //     return {
    //       label: x["name"],
    //       value: x["id"],
    //     };
    //   });

    //   // return GeoCurrencyArray;
    //   return [
    //     {
    //       label: "NA",
    //       value: null,
    //     },
    //     ...GeoCurrencyArray,
    //   ];
    // },

    // formRegs: function () {
    //   let regsArray = this.formInit["reg_ids"]
    //     ? this.formInit["reg_ids"].map((x) => {
    //         return {
    //           //   label: x["name"] + " - " + x["cnic_id"],
    //           label: x["name"],
    //           value: x["id"],
    //           country_id: x["country_id"],
    //           cnic_id: x["cnic_id"],
    //           name: x["name"],
    //           user: x["user_id"],
    //         };
    //       })
    //     : [];

    //   return regsArray;
    // },

    promoTld: function () {
      return this.LocalTldValue;
    },
  },
  mounted() {
    this.$root.$on("selectedGroupEditCNIC", (nodeData, extended, editReq) => {
      if(extended) {
        this.extended = true;
      }

      if(editReq) {
        this.editReq = true;
      }

      this.formatGroupEditData(nodeData);
      this.editPromoRequestPopup = true;
      this.formData['actionName'] = 'Edit';
    });

    this.$root.$on("duplicatePromoCNIC", (nodeData) => {
      this.formatSingleDuplicateData(nodeData);
      this.formData['actionName'] = 'Duplicate';
      this.editPromoRequestPopup = true;
      this.flags["duplicatebtn"] = true;
    });
  },
  beforeMount() {},
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },

    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    onFromChangeCNIC(event, counter) {
      this.$set(
        this.cnicpromo[counter].configTodateTimePicker,
        "minDate",
        event[0]
      );
    },

    onToChangeCNIC(event, counter) {
      this.$set(
        this.cnicpromo[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },

    formatGroupEditData(selectedRowData) {
      // console.log('selectedRowData :>> ', selectedRowData);
      
      this.cnicpromo.splice(0);

      var rowData = selectedRowData.map((x) => x.data);
      // console.log(rowData);
      var approvedCheck = rowData.map((x) => x.approved_by);
      // console.log(approvedCheck);

      if (approvedCheck.some(x => x)) {
        this.flags["disableInput"] = true;
        // console.log("yes", approvedCheck);
      } else {
        this.flags["disableInput"] = false;
        // console.log("no", approvedCheck);
      }

      var getRegistrar, getGroup, getTld, getPremium, getStartDates, getCNICID;

      getRegistrar = rowData.map((x) => {
        return {
          label: x.new_registrar.unique_registrar.name,
          countryId: x.new_registrar.unique_registrar.country_id,
          value: x.new_registrar.id,
        };
      });

      getGroup = rowData.map((x) => {
        return {
          id: x.group ? x.group.id : null,
          name: x.group ? x.group.name : null,
        };
      });

      getTld = rowData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld.id,
        };
      });

      getPremium = rowData.map((x) => {
        if (x.premium === 0) {
          return {
            label: "No",
            value: 0,
          };
        } else {
          return {
            label: "Yes",
            value: 1,
          };
        }
      });

      getCNICID = rowData.map((x) => {
        return x.new_registrar.cnic_id;
      });

      var currentDateWithFormat = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");

      //console.log(currentDateWithFormat);

      getStartDates = rowData.map((x) => {
        if (currentDateWithFormat > x.start_date) {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: x.start_date,
          };
        } else {
          //console.log('future');
          // this.flags["isPastDate"] = false;

          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: null,
          };
        }
      });

      for (var index = 0; index < rowData.length; index++) {
        this.cnicpromo.push({
          id: rowData.map((x) => x.id)[index],
          reg_id: getRegistrar[index],
          tld_id: getTld[index],
          cnic_id: getCNICID[index],
          effective_price_amt: rowData.map((x) => x.effective_price_amt)[index],
          effective_price_per: rowData.map((x) => x.effective_price_per)[index],
          premium: getPremium[index],
          type_of_reg: rowData.map((x) => x.type_of_reg)[index],
          group_id: rowData.map((x) => x.group_id)[index],
          start_date: getStartDates[index]["start_date"],
          end_date: rowData.map((x) => x.end_date)[index],
          start_time: rowData.map((x) => x.start_time)[index],
          end_time: rowData.map((x) => x.end_time)[index],
          promo_name: rowData.map((x) => x.promo_name)[index],
          status: rowData.map((x) => x.status)[index],
          comments: rowData.map((x) => x.comments)[index],
          configFromdateTimePicker: {
            minDate: getStartDates[index]["configPastFromdateTimePicker"],
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: getGroup[index].id
            ? getGroup[index].name.split(" ").join("-")
            : "",
          selectedClient: getRegistrar[index].label.split(" ").join("-"),
        });
      }
    },

    formatSingleDuplicateData(selectedRowData) {
      this.cnicpromo.splice(0);

      var rowData = selectedRowData.map((x) => x.data);

      var getRegistrar, getGroup, getTld, getPremium, getStartDates, getAgreements, getCNICID;

      getRegistrar = rowData.map((x) => {
        return {
          label: x.new_registrar.unique_registrar.name,
          countryId: x.new_registrar.unique_registrar.country_id,
          value: x.new_registrar.id,
        };
      });

      getGroup = rowData.map((x) => {
        return {
          id: x.group ? x.group.id : null,
          name: x.group ? x.group.name : null,
        };
      });

      getTld = rowData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld.id,
        };
      });

      getPremium = rowData.map((x) => {
        if (x.premium === 0) {
          return {
            label: "No",
            value: 0,
          };
        } else {
          return {
            label: "Yes",
            value: 1,
          };
        }
      });

      getCNICID = rowData.map((x) => {
        return x.new_registrar.cnic_id;
      });

      var currentDateWithFormat = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");


      getStartDates = rowData.map((x) => {
        if (currentDateWithFormat > x.start_date) {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: currentDateWithFormat,
          };
        } else {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: currentDateWithFormat,
          };
        }
      });

      getAgreements = rowData[0].agreement_new.map(x => x.id);

      for (var index = 0; index < rowData.length; index++) {

        this.cnicpromo.push({
          id: rowData.map((x) => x.id)[index],
          reg_id: getRegistrar[index],
          tld_id: getTld[index],
          cnic_id: getCNICID[index],
          effective_price_amt: rowData.map((x) => x.effective_price_amt)[index],
          effective_price_per: rowData.map((x) => x.effective_price_per)[index],
          premium: getPremium[index],
          type_of_reg: rowData.map((x) => x.type_of_reg)[index],
          group_id: rowData.map((x) => x.group_id)[index],
          start_date: null,
          end_date: null,
          start_time: rowData.map((x) => x.start_time)[index],
          end_time: rowData.map((x) => x.end_time)[index],
          promo_name: rowData.map((x) => x.promo_name)[index],
          status: rowData.map((x) => x.status)[index],
          comments: rowData.map((x) => x.comments)[index],
          configFromdateTimePicker: {
            minDate: getStartDates[index]["configPastFromdateTimePicker"],
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: getGroup[index].id
            ? getGroup[index].name.split(" ").join("-")
            : "",
          selectedClient: getRegistrar[index].label.split(" ").join("-"),
          general_agreements: getAgreements,
          unique_registrar_id: rowData[0].new_registrar.unique_registrar_id
        });
      }
    },

    onSubmit() {
      var cnicPriceObject = {
        amtNum: [],
        perNum: [],
      };

      this.cnicpromo.forEach((x) => {
        if (x.premium.value == 0) {
          cnicPriceObject["amtNum"].push(
            (Math.round(x.effective_price_amt * 100) / 100).toFixed(2)
          );
          cnicPriceObject["perNum"].push(0);
        } else {
          cnicPriceObject["amtNum"].push(0);
          cnicPriceObject["perNum"].push(
            (Math.round(x.effective_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      var cnicPromoData = {};

      cnicPromoData = this.cnicpromo.map((x, index) => {
        return {
          id: x.id,
          promo_name: x.promo_name,
          // registrar_id: x.reg_id.value,
          new_registrar_id: x.reg_id.value,
          tld_id: x.tld_id.value,
          premium: x.premium.value,
          type_of_reg: x.type_of_reg,
          start_date: x.start_date,
          end_date: x.end_date,
          start_time: x.start_time,
          end_time: x.end_time,
          effective_price_amt: cnicPriceObject["amtNum"][index],
          effective_price_per: cnicPriceObject["perNum"][index],
          status: "approval pending",
          comments: x.comments,
        };
      });

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          this.$axiosSecure
            .post("/cnic-promos-requests/edit", cnicPromoData)
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              // console.log(response.data);
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "CNIC Promo edited",
                  text: "Selected CNIC Promo(s) have been successfully edited.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
                this.editPromoRequestPopup = false;
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              setTimeout(() => {
                if (
                  error.response.data.resoneOfError == "CNIC duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else if(error.response.data.type == "Error" && error.response.data.data && error.response.data.data.length) {
                  this.cnicpromo = this.cnicpromo.filter(x => error.response.data.data.includes(x.id));
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onEditSubmit() {
      var cnicPromoData = {};

      cnicPromoData = this.cnicpromo.map((x, index) => {
        return {
          cnic_promo_id: x.id,
          end_date: x.end_date,
          end_time: x.end_time,
          status: "edit pending",
          comments: x.comments,
          extended: this.extended,
        };
      });

      // console.log("cnicPromoData", cnicPromoData);
      // return;

      this.$validator.validateAll().then((result) => {
        // console.log("form", result);
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          this.$axiosSecure
            .post("/cnic-promos/edit", cnicPromoData)
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              // console.log(response.data);
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "CNIC Promo edited",
                  text: "Selected CNIC Promo(s) have been successfully edited.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              //   console.log(error.response.message);
              setTimeout(() => {
                //Error msg
                if (
                  error.response.data.resoneOfError == "CNIC duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onDuplicateSubmit() {
      var cnicPriceObject = {
        amtNum: [],
        perNum: [],
      };

      this.cnicpromo.forEach((x) => {
        if (x.premium.value == 0) {
          cnicPriceObject["amtNum"].push(
            (Math.round(x.effective_price_amt * 100) / 100).toFixed(2)
          );
          cnicPriceObject["perNum"].push(0);
        } else {
          cnicPriceObject["amtNum"].push(0);
          cnicPriceObject["perNum"].push(
            (Math.round(x.effective_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      var cnicPromoData = {};

      // cnicPromoData = this.cnicpromo.map((x, index) => {
      //   return {
      //     promo_name: x.promo_name,
      //     registrar_id: x.reg_id.value,
      //     tld_id: x.tld_id.value,
      //     premium: x.premium.value,
      //     type_of_reg: x.type_of_reg,
      //     start_date: x.start_date,
      //     end_date: x.end_date,
      //     start_time: x.start_time,
      //     end_time: x.end_time,
      //     effective_price_amt: cnicPriceObject["amtNum"][index],
      //     effective_price_per: cnicPriceObject["perNum"][index],
      //     status: "approval pending",
      //     comments: x.comments,
      //   };
      // });

      cnicPromoData = this.cnicpromo.map((x, index) => {
        return {
          new_registrar_id: [this.cnicpromo[0].reg_id.value],
          tld_id: [x.tld_id.value],
          effective_price_amt: cnicPriceObject["amtNum"][index],
          effective_price_per: cnicPriceObject["perNum"][index],
          premium: x.premium.value,
          type_of_reg: x.type_of_reg,
          start_date: x.start_date,
          end_date: x.end_date,
          start_time: x.start_time,
          end_time: x.end_time,
          promo_name: this.PromoNamePartRecommendation[index].map(
            (x) => x.name
          ),
        };
      });

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          this.$axiosSecure
            .post("/cnic-promos-request/duplicate", {
              user_id: JSON.parse(localStorage.getItem("userDetails")).id,
              status: "approval pending",
              comments: this.cnicpromo[0]["comments"],
              unique_registrar_id: this.cnicpromo[0]["unique_registrar_id"],
              general_agreements: this.cnicpromo[0].general_agreements,
              cnic: cnicPromoData,
            })
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              // console.log(response.data);
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Thank You",
                  text: "CNIC Promo has been successfully created.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              //console.log(error.response.message);
              setTimeout(() => {
                //Error msg
                if (
                  error.response.data.resoneOfError == "CNIC duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    resetFields() {
      (this.batchId = ""), (this.formData["reg_id"] = []);
      this.formData["selectedPromoName"]["selectedGroup"] = "";
      this.formData["selectedPromoName"]["selectedTLD"] = "";
      this.formData["selectedPromoName"]["selectedClient"] = "";
      this.formData["selectedPromoName"]["selectedType"] = "";
      this.formData["selectedPromoName"]["selectedPrem"] = "";
      this.formData["selectedPromoName"]["selectedMonthYear"] = "";
      this.formData["selectedPromoName"]["selectedClientId"] = "";
      this.formData["selectedPromoName"]["selectedCountryId"] = "";
      this.formData["promo_name_new"] = "";
      this.formData["status"] = "approval pending";
      this.formData["displayTimezone"] = "(UTC)";
      this.formData["CNICRequired"] = "required";
      //   this.formData["payment_mode"] = [];
      //   this.formData["list_frequency"] = [];
      //   this.formData["list_based"] = "1";
      //   this.formData["agreement"] = { label: "New", value: null };
      //   (this.formData["new_general_agreement"] = null),
      //     (this.formData["status"] = ""),
      //     (this.uploadedFile = ""),
      // this.promos.forEach((element) => {
      //   (element.type = []),
      //     (element.tld_id = []),
      //     (element.period = []),
      //     (element.start_date = null),
      //     (element.end_date = null),
      //     (element.retail_price = ""),
      //     (element.year_price = ""),
      //     (element.multi_year_price = ""),
      //     (element.year_price_per = ""),
      //     (element.multi_year_price_per = ""),
      //     (element.promo_tag = []),
      //     (element.custom_tag = []),
      //     (element.geo = []),
      //     (element.comments = ""),
      //     (element.id = ""),
      //     (element.fileLocalData = []),
      //     (element.uploadedLocalFile = ""),
      //     (element.selectableOption = ""),
      //     (element.status = ""),
      //     (element.new_local_agreement = null);
      // });

      this.cnicpromo.forEach((element) => {
        (element.checkBox = false),
          (element.promo_name = ""),
          (element.tld_id = []),
          (element.effective_price_amt = ""),
          (element.effective_price_per = ""),
          (element.price_type = [{ label: "$", value: "$" }]),
          (element.premium = { label: "No", value: 0 }),
          (element.type_of_reg = ""),
          (element.start_date = null),
          (element.end_date = null),
          (element.start_time = "00:00:00"),
          (element.end_time = "23:59:59"),
          (element.configFromdateTimePicker = {
            minDate: new Date(),
            maxDate: null,
          }),
          (element.configTodateTimePicker = {
            minDate: null,
            allowInput: true
          });
      });
      //Remove all the repetative form data and keep only one
      this.cnicpromo.splice(1);
    },

    tableRefresh() {
      this.$root.$emit("tableRefresh");
    },

    promoNameFormations() {
      (this.PromoNamePartRecommendation = []), (this.promoNameSpan = []);

      this.cnicpromo.forEach((element) => {
        if (element["reg_id"]) {
          element["selectedClient"] = element["reg_id"].label
            .split(" ")
            .join("-");
        }

        const prefix = process.env.VUE_APP_PREFIX_ENV == "production" ? "" : "staging.";

        let part1 =
            element["selectedGroup"] !== ""
              ? prefix + element["selectedGroup"]
              : prefix + element["selectedClient"],
          selectedTld,
          selectedType,
          selectedPremium,
          selectedMonthYear,
          promoNameArray = [];

        if (element["tld_id"]) {
          this.tldValue = [
            {
              label: element["tld_id"].label,
              value: element["tld_id"].value,
            },
          ];

          const tldString = this.tldValue
            .map((x) => x.label)
            .toString()
            .split(".");
          const tldStringJoin = tldString.join("-");

          selectedTld = tldStringJoin;
        }

        if (element["type_of_reg"] == "Registration") {
          selectedType = "Reg";
        } else if (element["type_of_reg"] == "Renewal") {
          selectedType = "Ren";
        } else {
          selectedType = "";
        }

        if (element["premium"].value == 1) {
          selectedPremium = "Prem";
        } else {
          selectedPremium = "";
        }

        if (element["start_date"]) {
          var startDate = this.$moment(element["start_date"]);
          var monYear = startDate.format("MMM") + "." + startDate.format("YY");
          selectedMonthYear = monYear;
        }

        this.formData["promo_name_new"] = `${
          part1 != "" && part1 != undefined ? part1 : ""
        }${
          element['group_id'] == null ? "." + element['cnic_id'] : ""
        }${
          selectedTld != "" && selectedTld != undefined ? "." + selectedTld : ""
        }${
          selectedType != "" && selectedType != undefined
            ? "." + selectedType
            : ""
        }${
          selectedPremium != "" && selectedPremium != undefined
            ? "." + selectedPremium
            : ""
        }${
          selectedMonthYear != "" && selectedMonthYear != undefined
            ? "." + selectedMonthYear
            : ""
        }`;

        const name = this.formData["promo_name_new"];
        const nameArray = name.split(".");
        const nameString = nameArray.slice(2).join(".");
        const clientArray =
          nameArray[0] !== undefined ? nameArray[0].split(",") : [];
        const tldArray =
          nameArray[1] !== undefined ? nameArray[1].split(",") : [];
        // clientArray.forEach((x, index) => {
        //   tldArray.forEach((y) => {
        //     promoNameArray.push({
        //       name: `${x}.${y}.${nameString}`,
        //     });
        //   });
        // });
        // clientArray.forEach((x, index) => {
        //     element["selectedCNICIDs"].split(', ').forEach(y => {
        //         tldArray.forEach((z) => {
        //             // console.log('x, y :>> ', x, y);
        //             if(element['group_id'] && element['group_id'].hasOwnProperty('label')) {
        //                 promoNameArray.push({
        //                     name: `${prefix}${x}.${z}.${nameString}`,
        //                     // id: this.formData["selectedPromoName"]["selectedClientId"][index]
        //                 });
        //             } else {
        //                 promoNameArray.push({
        //                     name: `${prefix}${x}.${y}.${z}.${nameString}`,
        //                     // id: this.formData["selectedPromoName"]["selectedClientId"][index]
        //                 });
        //             }
        //         })
        //     });
        // });

        if(element['group_id']) {
          clientArray.forEach((x, index) => {
            tldArray.forEach((z) => {
              promoNameArray.push({
                  name: `${prefix}${x}.${z}.${nameString}`,
                  // id: this.formData["selectedPromoName"]["selectedClientId"][index]
              });
            })
          })
        } else {
            clientArray.forEach((x, index) => {
                tldArray.forEach((z) => {
                  promoNameArray.push({
                    name: `${prefix}${x}.${element['cnic_id']}.${z}.${nameString}`,
                          // id: this.formData["selectedPromoName"]["selectedClientId"][index]
                  });
                  // console.log('promoNameArray :>> ', promoNameArray);
                })
            })
        }

        this.PromoNamePartRecommendation.push(promoNameArray);
        this.promoNameSpan = [
          ...this.promoNameSpan,
          ...promoNameArray.map((x) => x.name),
        ];
        // element["promo_name"] = this.promoNameSpan.toString();
        element["promo_name"] = this.formData["promo_name_new"];
      });
    },

    changeTimeZone() {
      this.cnicpromo.forEach((cp) => {
        //TimeZone changed for China client
        if (
          cp["reg_id"] &&
          cp["reg_id"]["country_id"] &&
          cp["reg_id"]["country_id"] == "38"
        ) {
          cp["start_time"] = cp["start_time"] + "16:00:00";
          cp["end_time"] = cp["end_time"] + "15:59:59";

          cp["displayTimezone"] = "(UTC+08:00)";
        } 
        else {
          cp["start_time"] = cp["start_time"];
          cp["end_time"] = cp["end_time"];

          cp["displayTimezone"] = "(UTC)";
        }
      });
    },

    copyEndDate() {
      navigator.clipboard.readText().then(
          (textCopied) => {
            this.cnicpromo.map(x => {
              x.end_date = textCopied.toString();
            })
          },
          (err) => {
              console.error('Could not paste text: ', err)
          }
      );
    }
  },
};
</script>